"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
if (typeof Buffer === 'undefined') {
    global.Buffer = require('buffer').Buffer;
}
if (typeof process === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    global.process = {};
}
if (typeof process.version === 'undefined') {
    global.process.version = '';
}
var Affinity_1 = require("./Affinity");
Object.defineProperty(exports, "Affinity", { enumerable: true, get: function () { return Affinity_1.Affinity; } });
Object.defineProperty(exports, "Affinidi", { enumerable: true, get: function () { return Affinity_1.Affinity; } });
var ProfilerDecorator_1 = require("./shared/profiler/ProfilerDecorator");
Object.defineProperty(exports, "profile", { enumerable: true, get: function () { return ProfilerDecorator_1.profile; } });
Object.defineProperty(exports, "ProfileAction", { enumerable: true, get: function () { return ProfilerDecorator_1.ProfileAction; } });
var services_1 = require("./services");
Object.defineProperty(exports, "DidDocumentService", { enumerable: true, get: function () { return services_1.DidDocumentService; } });
Object.defineProperty(exports, "DigestService", { enumerable: true, get: function () { return services_1.DigestService; } });
Object.defineProperty(exports, "JwtService", { enumerable: true, get: function () { return services_1.JwtService; } });
Object.defineProperty(exports, "KeysService", { enumerable: true, get: function () { return services_1.KeysService; } });
Object.defineProperty(exports, "MetricsService", { enumerable: true, get: function () { return services_1.MetricsService; } });
//# sourceMappingURL=index.js.map